import actionTypes from "./actionTypes";

const initialState = {
  accessToken: null,
  isAuthenticated: false,
  isLoading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.AUTHENTICATE_ERROR:
    case actionTypes.LOGOUT_SUCCESS:
      return initialState;

    case actionTypes.AUTHENTICATE_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
      };

    case actionTypes.STORE_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case actionTypes.STORE_ACCESS_TOKEN:
      return {
        ...state,
        accessToken: action.payload,
      };

    case actionTypes.UPDATE_ACCESS_TOKEN:
      return {
        ...state,
        accessToken: action.payload,
      };

    default:
      return state;
  }
}
